"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalWithButton = exports.ModalWithButton = exports.useModelState = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var Modal_1 = __importDefault(require("../Modal"));
function useModelState(init) {
    if (init === void 0) { init = false; }
    var _a = react_1.useState(init), visible = _a[0], setVisible = _a[1];
    // handlers;
    var closeModal = function () { return setVisible(false); };
    var openModal = function () { return setVisible(true); };
    var toggleModal = function () { return setVisible(function (p) { return !p; }); };
    return [{ visible: visible }, { closeModal: closeModal, openModal: openModal, toggleModal: toggleModal }];
}
exports.useModelState = useModelState;
function ModalWithButton(_a) {
    var children = _a.children, modelProps = _a.modelProps, _b = _a.buttonProps, buttonProps = _b === void 0 ? {} : _b;
    var _c = useModelState(), visible = _c[0].visible, _d = _c[1], closeModal = _d.closeModal, openModal = _d.openModal, toggleModal = _d.toggleModal;
    // conts;
    var _e = modelProps || {}, _f = _e.Component, ModalElement = _f === void 0 ? Modal_1.default : _f, restModalProps = __rest(_e, ["Component"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ModalElement, __assign({}, restModalProps, { visible: visible, onClose: closeModal }), children({ closeModal: closeModal, openModal: openModal, toggleModal: toggleModal })),
        react_1.default.createElement(antd_1.Button, __assign({}, buttonProps, { onClick: openModal }))));
}
exports.ModalWithButton = ModalWithButton;
function useModalWithButton(_a) {
    var _b, _c;
    var children = _a.children, modelProps = _a.modelProps, _d = _a.buttonProps, buttonProps = _d === void 0 ? {} : _d, initialState = _a.initialState, statefulProps = _a.statefulProps;
    var _e = react_1.useState(initialState), state = _e[0], setState = _e[1];
    var _f = useModelState(), visible = _f[0].visible, _g = _f[1], closeModal = _g.closeModal, openModal = _g.openModal, toggleModal = _g.toggleModal;
    // conts;
    var _h = modelProps || {}, _j = _h.Component, ModalElement = _j === void 0 ? Modal_1.default : _j, restModalProps = __rest(_h, ["Component"]);
    return {
        jsx: {
            button: (react_1.default.createElement(antd_1.Button, __assign({}, buttonProps, (((_b = statefulProps === null || statefulProps === void 0 ? void 0 : statefulProps(state)) === null || _b === void 0 ? void 0 : _b.buttonProps) || {}), { onClick: openModal }))),
            modal: (react_1.default.createElement(ModalElement, __assign({}, restModalProps, (((_c = statefulProps === null || statefulProps === void 0 ? void 0 : statefulProps(state)) === null || _c === void 0 ? void 0 : _c.modelProps) || {}), { visible: visible, onClose: closeModal }), children({ closeModal: closeModal, openModal: openModal, toggleModal: toggleModal, state: state }))),
        },
        state: state,
        utils: {
            closeModal: closeModal,
            openModal: openModal,
            setState: setState,
            toggleModal: toggleModal,
        },
    };
}
exports.useModalWithButton = useModalWithButton;
